import React from "react";
import PropTypes from "prop-types";
import utils from "@utils";
import { Modal } from "../../../../components";

import "./BillingHistoryModal.scss";

const BillingHistoryModal = props => {
	const { lang } = global;
	const { show, onHide, billingHistory, TimeZoneId, leaName } = props;

	return (
		<Modal
			id="billing-history-modal"
			dialogClassName="billing-modal-dialog"
			size="lg"
			show={show}
			onHide={() => onHide()}
		>
			<Modal.Header
				closeButton
				className="hidden-print"
			>
				<Modal.Title>Billing History</Modal.Title>
			</Modal.Header>
			<Modal.Body className="container-fluid">
				<div className="billing-history-table">
					<h2 className="visible-print">{leaName}</h2>
					<table className="table table-bordered">
						<thead>
							<tr>
								<th>{lang.t("Invoice Number")}</th>
								<th>{lang.t("Created")}</th>
								<th>{lang.t("Start Period")}</th>
								<th>{lang.t("End Period")}</th>
								<th>{lang.t("Status")}</th>
								<th>{lang.t("Total")}</th>
								<th className="hidden-print">{lang.t("Invoice Details")}</th>
							</tr>
						</thead>
						<tbody>
							<For
								each="invoice"
								index="index"
								of={billingHistory}
							>
								<tr key={`officer_${invoice.InvoiceId}`}>
									<td>{invoice.InvoiceNumber ?? ""}</td>
									<td>
										{utils.formatDate(
											invoice.Created,
											"en-US",
											TimeZoneId,
											"numeric",
										)}
									</td>
									<td>
										{utils.formatDate(
											invoice.PeriodStart,
											"en-US",
											TimeZoneId,
											"numeric",
										)}
									</td>
									<td>
										{utils.formatDate(
											invoice.PeriodSEnd,
											"en-US",
											TimeZoneId,
											"numeric",
										)}
									</td>
									<td className="text-capitalize">{invoice.Status ?? ""}</td>
									<td>{utils.currencyFormatter(invoice.Total ?? "0")}</td>
									<td className="hidden-print">
										<a
											href={invoice.HostedInvoiceUrl}
											target="_blank"
											rel="noopener noreferrer"
										>
											{lang.t("Additional Details")}
										</a>
									</td>
								</tr>
							</For>
						</tbody>
					</table>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button
					id="button-go-back"
					className="btn btn-link hidden-print"
					type="button"
					onClick={() => onHide()}
				>
					{lang.t("Close")}
				</button>
				<button
					id="button-print-table"
					className="btn btn-primary hidden-print"
					type="button"
					onClick={() => window.print()}
				>
					{lang.t("Print")}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

BillingHistoryModal.propTypes = {
	show: PropTypes.bool,
	onHide: PropTypes.func,
	leaName: PropTypes.string,
	billingHistory: PropTypes.array.isRequired,
	TimeZoneId: PropTypes.string.isRequired,
};

BillingHistoryModal.defaultProps = {
	show: false,
	onHide: () => {},
	leaName: "",
};

export default BillingHistoryModal;
